<template>
  <div class="login">
    <v-layout>
      <v-flex>
    <!-- <v-container fluid> -->
        <h2 class="my-2">Please sign in:</h2>
        <v-card color="cardgray">
          <v-container>
            <v-form
                v-model="valid"
                ref="form"
                v-on:submit.prevent="signIn"
                lazy-validation
              >
              <v-text-field
                name="email"
                label="Email"
                v-model="email"
                :rules="emailRules"
                type="text"
                required
              ></v-text-field>

              <v-text-field
                name="password"
                label="Password"
                v-model="password"
                :rules="passwordRules"
                required
                type="password"
              ></v-text-field>

              <v-btn
                @click="signIn"
                :disabled="!valid"
                color="primary"
              >
                Log in
              </v-btn>
              <v-btn @click="clear">clear</v-btn>

            </v-form>
          </v-container>

          <v-container>

            <h4 v-if='errorMessage' style="color:#ed831a;" class="mt-1 mb-1">Error: {{ errorMessage }}</h4>
            <!-- <p> Don't have an account yet? You can <router-link to="/signup">create one.</router-link></p> -->
            <v-divider></v-divider>
            <h4 class='mt-3'>Don't have an account yet?<v-btn flat color="primary" to="signup">Create an account</v-btn></h4>
            <h4 class='mb-1'>Forgot your password?<v-btn flat color="primary" to="forgot-password">Reset password</v-btn></h4>

          </v-container>

<!--           <v-container>
            <input type="text" v-model="email" placeholder="email"><br>
            <input type="password" v-model="password" placeholder="password"><br>
            <v-btn color="primary" v-on:click="signIn">Log in</v-btn>
            <h4 v-if='errorMessage' style="color:#ed831a;" class="mt-4 mb-1">Error: {{ errorMessage }}</h4>
            <v-divider class="mt-5"></v-divider>
            <h4 class='mt-1'>Don't have an account yet?<v-btn flat color="primary" to="signup">Create an account</v-btn></h4>
            <h4 class='mb-1'>Forgot your password?<v-btn flat color="primary" to="forgot-password">Reset password</v-btn></h4>
          </v-container> -->
        </v-card>
      </v-flex>
    </v-layout>
    <!-- </v-container> -->
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'login',
  data: function () {
    return {
      email: '',
      password: '',
      // confirmPassword: '',
      errorMessage: null,
      valid: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /\S+@\S+\.\S+/.test(v) || 'E-mail must be valid' // anystring@anystring.anystring
      ],
      passwordRules: []
    }
  },
  created () {
    // console.log('Firebase user: ')
    // firebase.auth().currentUser.getIdToken(true).then(
    //   (idToken) => {
    //     this.$set(this.$data, 'idToken', idToken)
    //   })
    // console.log('Token: ', this.idToken)
  },
  // computed: {
  //   errorMessage: function () {
  //     // `this` points to the vm instance
  //     return this.$store.getters.errorMessage
  //   }
  // },

  // computed: {
  //   comparePasswords () {
  //     return this.password !== this.confirmPassword ? 'Passwords do not match' : ''
  //   },
  // },
  methods: {
    signIn: function () {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password)
      .then((user) => {
        // alert('You are now logged in.')
        // this.$router.push('challenge-details')
        this.$router.push('profile')
      },
      (err) => {
        // alert('Oops, that was not a valid login. Please try again...')
        // console.log(err)
        // console.log('error: ' + err.message)
        this.$set(this.$data, 'errorMessage', err.message)
        // this.$store.commit('setErrorMessage', err.message)

        // alert('Oops, that was not a valid login. Please try again: ' + err.message)
        // .then(this.$router.push('login'))
      })
    },
    clear () {
      this.$refs.form.reset()
    }
  }

}
</script>

<style scoped>
/*  .login {
    margin-top: 20px;
  }*/
  input {
    margin: 10px 0;
    width: 20%;
    padding: 15px;
  }
  button {
    margin-top: 20px;
    width: 10%;
    cursor: pointer;
    background: #dedede;
  }
  p {
    margin-top: 40px;
    font-size: 13px;
  }
  p a {
    text-decoration: underline;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/User/Login.vue